export default "__VITE_ASSET__7352b95a__"